import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResumeItem } from '../../../gen2ai/resume-robot.service';

export interface ResumeDialogData {
  resume: ResumeItem;
}

@Component({
  selector: 'app-resume-dialog-view',
  templateUrl: './resume-dialog-view.component.html',
  styleUrls: ['./resume-dialog-view.component.scss']
})
export class ResumeDialogViewComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ResumeDialogData,
    private dialogRef: MatDialogRef<ResumeDialogViewComponent>
  ) {}

  get resume(): ResumeItem {
    return this.data.resume;
  }

  close(): void {
    this.dialogRef.close();
  }

  openFile(): void {
    this.dialogRef.close({ action: 'openFile', resume: this.resume });
  }

  useInChat(): void {
    this.dialogRef.close({ action: 'useInChat', resume: this.resume });
  }
}
